export default "__VITE_ASSET__BKPAgG8J__"